/* HTTP service */

import axios from "axios";
import Settings from "./settings";
// import Events from "./events.service";
// import Errors from "./errors.service";
import Storage from "./storage.service";

var device = Math.floor(Math.random() * 10000000000 + 1); //Helpers.generateDeviceID();

var session_id = "";
var qualified_session_id = "";

const HTTP = axios.create({
	baseURL: Settings.base_url,
	headers: {
		"accept-version": Settings.api_version,
		"Virgin-Lang": "en",
		ChannelID: "Web",
		"Channel-Id": "Web",
		"Virgin-Device-Id": device,
		"Virgin-Device-Os": "Web",
	},
});

const HTTP_other = axios.create();

HTTP.defaults.headers.common["Accept"] = "application/json";

HTTP.defaults.headers.post["Content-Type"] =
	"application/x-www-form-urlencoded";

HTTP.interceptors.request.use(
	(config) => {
		if (config.url) {
			if (
			(config.url === '/securitymanagement/login' || config.url === '/securitymanagement/social_login')
				&& Storage.get("gclid", true)
			) {
				config.headers["Gclid"] = Storage.get("gclid", true);
				Storage.clear("gclid");
			}
		}
		let account_id = Storage.get("account_id");
		if (account_id) {
			config.headers["Virgin-Account-Number"] = account_id;
		}
		if (config.baseURL === Settings.base_url) {
			config.headers["Virgin-Device-Id"] = device;

			if (qualified_session_id) {
				config.headers["Session-Id"] = qualified_session_id;
			} else {
				if (session_id) {
					config.headers["Session-Id"] = session_id;
				}
			}
		}
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

HTTP.interceptors.response.use(null, (error) => {
	// let url = "";

	// if (error.response && error.response.config) {
	// 	url = error.response.config.url;
	// }

	// let code = Errors.getErrorCode(error);

	// let type = Errors.getErrorType(code);
	// Events.http_error(code, type, url);
	throw error;
});

HTTP.get_device_id = () => {
	return device;
};

HTTP.set_device_id = (val) => {
	device = val;
	window.localStorage.setItem("device_id", val);
};

HTTP.set_session = (val) => {
	if (Settings.debug_http) {
		console.warn("HTTP.set_session", val);
	}
	session_id = val;
	window.localStorage.setItem("session", val);
};

HTTP.set_qualified_session = (val) => {
	if (Settings.debug_http) {
		console.warn("HTTP.set_session", val);
	}
	qualified_session_id = val;
	window.localStorage.setItem("session", val);
};

HTTP.get_qualified_session = () => {
	return qualified_session_id;
};

export default HTTP;

export {HTTP_other};

